export function getParameterByName(name, url) {
  const location = url || window.location.href;
  const formattedName = name.replace(/[\[\]]/g, "\\$&");

  const regex = new RegExp(`[?&]${formattedName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(location);

  if (!results) return null;
  if (!results[2]) return "";

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export default "";



// WEBPACK FOOTER //
// ./src/utils/pl.js